<template>
  <default-dialog
    v-model="value" max-width="800px" max-height="800px"
    @accepted="accepted($event)"
    @closing="$emit('closing') "
  >
    <template #header>
      Add sample
    </template>

    <template #content>
      <v-container>
        <v-row>

        </v-row>
        <v-row>
          <v-col cols="12" full>
            <notes-editor v-model="inputs.notes" label="Notes">
            </notes-editor>
          </v-col>
        </v-row>
      </v-container>

    </template>

  </default-dialog>
</template>

<script>
	import {mapActions, mapGetters} from "vuex"

	import DefaultDialog from "../DefaultDialog"
	import NotesEditorComponent from "../NotesEditorComponent"

	export default {
		name: "sample-add-dialog",

		components: {
			DefaultDialog,
			NotesEditorComponent,
		},

		data: function () {
			return {
				inputs: {
					name: null,
					notes: null,
					patient: null,
					type: null,
				}
			}
		},

		props: {
			value: {type: Boolean, default: false,},
			sample: {type: Object, default: () => null},
		},

		computed: {
			...mapGetters({
				sampleType_items: 'lists/sampleType_items',
				patient_items: 'lists/patient_items',
			}),
		},

		methods: {
			...mapActions({
				sample_update_sample: 'sample/update_sample',

				message_add: 'message/add',
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
			}),

			/**
			 * логика обработки данных ввода
			 * @param val
			 * @returns {{}}
			 */
			cleanup_data: function (val) {
				let obj = {}

				for (let key in val) {
					obj[key] = val[key]
				}

				return obj
			},

			// -- Handle controls' events --

			accepted: function (event) {
				// TODO: тут можно какие-то данные поменять

				let obj = this.cleanup_data(this.inputs)

				const me = this
				me.progress_begin({message: "Update sample props..."})
				me.sample_update_sample(obj)
					.then(function (val) {
						event.result(true)
						me.message_add({type: 'success', html: 'Sample props updated.'})
					})
					.catch(function (error) {
						me.message_add(error)
					})
					.finally(function () {
						me.progress_end()
					})
			},
		}
	}
</script>

<style scoped>

</style>